/**
 * File: useDashboardPageController.ts
 * Path: apps/admin/src/features/dashboard/hooks/useDashboardPageController.ts
 * Description: Which dashboard the signed-in role sees: sales home, website analytics, or the plain role home.
 */

import { useRole } from "@/modules/auth/hooks/useRoleQueries";

export type DashboardView = "sales" | "analytics" | "role";

export const useDashboardPageController = (): { view: DashboardView } => {
  const { can } = useRole();
  if (can("sales")) return { view: "sales" };
  return { view: can("analytics") ? "analytics" : "role" };
};
